import { useCallback, useContext } from 'react';

import { HotjarContext } from './HotjarProvider';

type UseHotjarReturnValue =
  | {
      isHotjarEnabled: true;
      triggerHotjarEvent: (event: string) => void;
    }
  | {
      isHotjarEnabled: false;
      triggerHotjarEvent: undefined;
    };

export const useHotjar = (): UseHotjarReturnValue => {
  const hotjarContext = useContext(HotjarContext);
  const triggerHotjarEventFromContext = hotjarContext.triggerHotjarEvent;
  const isHotjarEnabled = Boolean(triggerHotjarEventFromContext);

  const triggerHotjarEvent = useCallback(
    (eventName: string) => {
      if (triggerHotjarEventFromContext) {
        triggerHotjarEventFromContext(eventName);
      }
    },
    [triggerHotjarEventFromContext],
  );

  return isHotjarEnabled
    ? { isHotjarEnabled: true, triggerHotjarEvent }
    : { isHotjarEnabled: false, triggerHotjarEvent: undefined };
};
